const Arrinera = [
    {
        ID: "arrinera_1",
        name: "Hussarya",
        brand: "Arrinera",
        price: 6.4,
        engine: "V8 6.2L",
        max: 340,
        version: "ZF 8",
        type: "Coupe",
        avatar: "https://i.ibb.co/zPzGFpP/hussarya-jpg.webp",
        link: "/brands/arrinera/hussarya",
        para: {
            priceus: "229,495",
            pricevn: "13,700,000,000",
            max100: 3.6,
            max200: 12.8,
            watt: "650 Hp / 6000",
            momem: "850 Nm / 2500",
            size: "5.112 x 2.016 x 1.638",
            sit: 5,
            long: 3003,
            mam: "21-23",
            hopso: "Tự động 8 cấp",
            dandong: "4 Cầu - AWD",
            tilenen: "-",
            treo: "Khí nén",
            phanh: "Gốm Carbon CCB tiêu chuẩn",
        },
    },
];
export default Arrinera;
